var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkin-code"},[(!_vm.qrcode)?_c('loading-spinner'):_vm._e(),_c('div',{staticClass:"checkin-code__box",domProps:{"innerHTML":_vm._s(_vm.qrcode)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }